export default __webpack_public_path__ + "static/media/pentest_2.c95d42cd.svg";